/* eslint-disable */

export const states_lby =
{
    "list": [
        {
            "id": "LBY001",
            "name": "طرابلس",
            "nameAr": null,
            "code": "001",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY002",
            "name": "ضواحي طرابلس",
            "nameAr": null,
            "code": "002",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY003",
            "name": "تاجوراء",
            "nameAr": null,
            "code": "003",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY004",
            "name": "بنغازي",
            "nameAr": null,
            "code": "004",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY005",
            "name": "البيضاء",
            "nameAr": null,
            "code": "005",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY006",
            "name": "مسة",
            "nameAr": null,
            "code": "006",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY007",
            "name": "قصر ليبيا",
            "nameAr": null,
            "code": "007",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY008",
            "name": "مصراتة",
            "nameAr": null,
            "code": "008",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY009",
            "name": "الزاوية",
            "nameAr": null,
            "code": "009",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY010",
            "name": "صرمان",
            "nameAr": null,
            "code": "010",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY011",
            "name": "صبراتة",
            "nameAr": null,
            "code": "011",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY012",
            "name": "العجيلات",
            "nameAr": null,
            "code": "012",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY013",
            "name": "الطويلة",
            "nameAr": null,
            "code": "013",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY014",
            "name": "الجميل",
            "nameAr": null,
            "code": "014",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY015",
            "name": "زوارة",
            "nameAr": null,
            "code": "015",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY016",
            "name": "رقدالين",
            "nameAr": null,
            "code": "016",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY017",
            "name": "زلطن",
            "nameAr": null,
            "code": "017",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY018",
            "name": "ابو كماش",
            "nameAr": null,
            "code": "018",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY019",
            "name": "راس الجدير",
            "nameAr": null,
            "code": "019",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY020",
            "name": "الجفرة",
            "nameAr": null,
            "code": "020",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY021",
            "name": "سوكنة",
            "nameAr": null,
            "code": "021",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY022",
            "name": "هون",
            "nameAr": null,
            "code": "022",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY023",
            "name": "ودان",
            "nameAr": null,
            "code": "023",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY024",
            "name": "الفقهاء",
            "nameAr": null,
            "code": "024",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY025",
            "name": "زلة",
            "nameAr": null,
            "code": "025",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY026",
            "name": "زليتن",
            "nameAr": null,
            "code": "026",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY027",
            "name": "الخمس",
            "nameAr": null,
            "code": "027",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY028",
            "name": "قصر الأخيار",
            "nameAr": null,
            "code": "028",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY029",
            "name": "غوط الرمان",
            "nameAr": null,
            "code": "029",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY030",
            "name": "وادي كعام",
            "nameAr": null,
            "code": "030",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY031",
            "name": "الجبل الغربي",
            "nameAr": null,
            "code": "031",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY032",
            "name": "غريان",
            "nameAr": null,
            "code": "032",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY033",
            "name": "الأصابعة",
            "nameAr": null,
            "code": "033",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY034",
            "name": "يفرن",
            "nameAr": null,
            "code": "034",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY035",
            "name": "الزنتان",
            "nameAr": null,
            "code": "035",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY036",
            "name": "الرجبان",
            "nameAr": null,
            "code": "036",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY037",
            "name": "الرحيبات",
            "nameAr": null,
            "code": "037",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY038",
            "name": "بدر",
            "nameAr": null,
            "code": "038",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY039",
            "name": "تيجي",
            "nameAr": null,
            "code": "039",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY040",
            "name": "طمزين",
            "nameAr": null,
            "code": "040",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY041",
            "name": "كاباو",
            "nameAr": null,
            "code": "041",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY042",
            "name": "نالوت",
            "nameAr": null,
            "code": "042",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY043",
            "name": "وازن",
            "nameAr": null,
            "code": "043",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY044",
            "name": "الجوش",
            "nameAr": null,
            "code": "044",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY045",
            "name": "الرياينة",
            "nameAr": null,
            "code": "045",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY046",
            "name": "جادو",
            "nameAr": null,
            "code": "046",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY047",
            "name": "العوينية",
            "nameAr": null,
            "code": "047",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY048",
            "name": "الشقيقة",
            "nameAr": null,
            "code": "048",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY049",
            "name": "سرت ",
            "nameAr": null,
            "code": "049",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY050",
            "name": "السدرة",
            "nameAr": null,
            "code": "050",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY051",
            "name": "العقيلة",
            "nameAr": null,
            "code": "051",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY052",
            "name": "سبها",
            "nameAr": null,
            "code": "052",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY053",
            "name": "الشويرف",
            "nameAr": null,
            "code": "053",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY054",
            "name": "ترهونة",
            "nameAr": null,
            "code": "054",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY055",
            "name": "مسلاتة",
            "nameAr": null,
            "code": "055",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY056",
            "name": "اجدابيا",
            "nameAr": null,
            "code": "056",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY057",
            "name": "طبرق",
            "nameAr": null,
            "code": "057",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY058",
            "name": "المرج",
            "nameAr": null,
            "code": "058",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY059",
            "name": "درنة",
            "nameAr": null,
            "code": "059",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY061",
            "name": "القبة",
            "nameAr": null,
            "code": "061",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY062",
            "name": "شحات",
            "nameAr": null,
            "code": "062",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY063",
            "name": "الابرق",
            "nameAr": null,
            "code": "063",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY064",
            "name": "جالو",
            "nameAr": null,
            "code": "064",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY065",
            "name": "اوجلة",
            "nameAr": null,
            "code": "065",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY066",
            "name": "الكفرة",
            "nameAr": null,
            "code": "066",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY067",
            "name": "تازربو",
            "nameAr": null,
            "code": "067",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY068",
            "name": "البياضة",
            "nameAr": null,
            "code": "068",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY069",
            "name": "التميمي",
            "nameAr": null,
            "code": "069",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY070",
            "name": "اجخرة",
            "nameAr": null,
            "code": "070",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY071",
            "name": "سوسة",
            "nameAr": null,
            "code": "071",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY072",
            "name": "اسبيعة",
            "nameAr": null,
            "code": "072",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY073",
            "name": "مزدة",
            "nameAr": null,
            "code": "073",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY074",
            "name": "بني وليد",
            "nameAr": null,
            "code": "074",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY075",
            "name": "امساعد",
            "nameAr": null,
            "code": "075",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY076",
            "name": "العلوص",
            "nameAr": null,
            "code": "076",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY077",
            "name": "القربوللي",
            "nameAr": null,
            "code": "077",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY078",
            "name": "القويعة",
            "nameAr": null,
            "code": "078",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY079",
            "name": "قماطه",
            "nameAr": null,
            "code": "079",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY080",
            "name": "ابوعيسي",
            "nameAr": null,
            "code": "080",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY081",
            "name": "الماية",
            "nameAr": null,
            "code": "081",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY082",
            "name": "المطرد",
            "nameAr": null,
            "code": "082",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY083",
            "name": "العلوص",
            "nameAr": null,
            "code": "083",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY084",
            "name": "القويعة",
            "nameAr": null,
            "code": "084",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY085",
            "name": "الماية",
            "nameAr": null,
            "code": "085",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY086",
            "name": "جدائم",
            "nameAr": null,
            "code": "086",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY087",
            "name": "القلعة",
            "nameAr": null,
            "code": "087",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY088",
            "name": "الناصرية",
            "nameAr": null,
            "code": "088",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY089",
            "name": "تراغن",
            "nameAr": null,
            "code": "089",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY090",
            "name": "ابوقرين",
            "nameAr": null,
            "code": "090",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY091",
            "name": "الترسانة",
            "nameAr": null,
            "code": "091",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY092",
            "name": "الرابطة",
            "nameAr": null,
            "code": "092",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY093",
            "name": "سوق السبت",
            "nameAr": null,
            "code": "093",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY094",
            "name": "السايح",
            "nameAr": null,
            "code": "094",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY095",
            "name": "ورشفاتة",
            "nameAr": null,
            "code": "095",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY096",
            "name": "غدامس",
            "nameAr": null,
            "code": "096",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY097",
            "name": "البريقة ",
            "nameAr": null,
            "code": "097",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY098",
            "name": "رأس الأنوف",
            "nameAr": null,
            "code": "098",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY099",
            "name": "براك الشاطيء",
            "nameAr": null,
            "code": "099",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY100",
            "name": "اوباري",
            "nameAr": null,
            "code": "100",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY101",
            "name": "مرزق",
            "nameAr": null,
            "code": "101",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY102",
            "name": "غات",
            "nameAr": null,
            "code": "102",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY103",
            "name": "القطرون",
            "nameAr": null,
            "code": "103",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY104",
            "name": "ام الارانب",
            "nameAr": null,
            "code": "104",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY105",
            "name": "الغريفة",
            "nameAr": null,
            "code": "105",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY106",
            "name": "بن جواد",
            "nameAr": null,
            "code": "106",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY107",
            "name": "هراوة",
            "nameAr": null,
            "code": "107",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        },
        {
            "id": "LBY108",
            "name": "نسمة",
            "nameAr": null,
            "code": "108",
            "countryId": "LBY",
            "createdAt": "2024-10-31T18:08:00.776Z",
            "updatedAt": "2024-10-31T18:08:00.776Z"
        }
    ]
}
